<template>
  <div class="divider">
    <div class="box">
      <h2><slot></slot></h2>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: 'SectionDivider',
};
</script>

<style lang="scss">
.divider {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  transform: translate(0, -50%);
  .line {
    position: absolute;
    margin: 13px 0;
    top: 0;
    bottom: 0;
    //margin: auto 0;
    left: 0;
    width: 100%;
    background: $text_gray;
    z-index: -1;
  }
  .box {
    background: $text_gray;
    display: inline-block;
    padding: 8px 15px;
    border-radius: 2px;
    h2 {
      margin: 0;
      color: $dark_bg;
      text-align: center;
      font-weight: 400;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionDivider.vue